import { Env } from "@stencil/core"

export const sellalongApiUrl = Env["SELLALONG_API_URL"]
export const sellalongApiKey = Env["SELLALONG_API_KEY"]

export const launchdarklyKey = Env["LAUNCHDARKLY_KEY"]

export const environment = Env["DEPLOY_ENVIRONMENT"]
